<template>
    <div class="row pt-1 pb-1 pr-1 partnership-block">
      <div class="col-4">Условия сотрудничеста</div>
      <div class="col-8 form-group">
        <div class="row pb-1">
          <div class="col-8">От установки</div>
          <div class="input-group col-4">
            <input
              class="form-control"
              type="number"
              v-model="partnership.commissionInstall"
              @input="changePartnership()"/>
            <span class="input-group-addon">
              %
            </span>
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-8">От рекламации</div>
          <div class="input-group col-4">
            <input
              class="form-control"
              type="number"
              v-model="partnership.commissionReclamation"
              @input="changePartnership()"/>
            <span class="input-group-addon">
              %
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-8">От продажи в розницу</div>
          <div class="input-group col-4">
            <input
              class="form-control"
              type="number"
              v-model="partnership.commissionRetail"
              @input="changePartnership()"/>
            <span class="input-group-addon">
              %
            </span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'TcPartnership',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      partnership: this.value
    }
  },
  methods: {
    changePartnership () {
      this.partnership.commissionInstall = parseInt(this.partnership.commissionInstall)
      this.partnership.commissionReclamation = parseInt(this.partnership.commissionReclamation)
      this.partnership.commissionRetail = parseInt(this.partnership.commissionRetail)
      this.$emit('input', this.partnership)
    }
  }
}
</script>

<style scoped>
.partnership-block {
  background: rgb(249, 249, 249);
  border-radius: 5px;
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// TcPartnership.vue?138d2cc3